import type { Organization } from '#/domain/organization/Organization'
import type { OrganizationRepository } from '#/domain/organization/OrganizationRepository'

export class GetOrganizationUseCase {
  constructor(private readonly repository: OrganizationRepository) {}

  async execute(id: string): Promise<Organization> {
    return this.repository.findById(id)
  }
}
